var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-tile"},[_c('v-btn',{staticClass:"scroll-to-message-button",attrs:{"absolute":"","icon":"","color":"orange"},on:{"click":_vm.scrollToMessage}},[_c('v-icon',[_vm._v("mdi-email-search")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }